class AdawatFlashSaleBanner extends HTMLElement {
  connectedCallback() {
    this.end = Date.parse(this.dataset.end || '');
    this.daysEl = this.querySelector('[data-flash-days]');
    this.hoursEl = this.querySelector('[data-flash-hours]');
    this.minsEl = this.querySelector('[data-flash-mins]');
    this.secsEl = this.querySelector('[data-flash-secs]');
    if (!this.end || Number.isNaN(this.end) || !this.daysEl) return;

    this.tick = this.tick.bind(this);
    this.tick();
    this.timer = window.setInterval(this.tick, 1000);
  }

  disconnectedCallback() {
    if (this.timer) window.clearInterval(this.timer);
  }

  pad(value) {
    return String(Math.max(0, value)).padStart(2, '0');
  }

  tick() {
    const diff = Math.max(0, this.end - Date.now());
    const totalSec = Math.floor(diff / 1000);
    const days = Math.floor(totalSec / 86400);
    const hours = Math.floor((totalSec % 86400) / 3600);
    const mins = Math.floor((totalSec % 3600) / 60);
    const secs = totalSec % 60;

    this.daysEl.textContent = this.pad(days);
    this.hoursEl.textContent = this.pad(hours);
    this.minsEl.textContent = this.pad(mins);
    this.secsEl.textContent = this.pad(secs);

    if (diff <= 0 && this.timer) {
      window.clearInterval(this.timer);
      this.timer = null;
    }
  }
}

if (!customElements.get('adawat-flash-sale-banner')) {
  customElements.define('adawat-flash-sale-banner', AdawatFlashSaleBanner);
}
